import { jsxs as n, jsx as r } from "react/jsx-runtime";
import { lazy as l, useState as u, useEffect as a, Suspense as c } from "react";
import { PersistQueryClientProvider as d } from "@tanstack/react-query-persist-client";
import { defaultShouldDehydrateQuery as m } from "./chunk423.js";
import { ReactQueryDevtools as f } from "./chunk424.js";
import { createQueryClient as p, createIDBPersister as y } from "./chunk342.js";
const h = l(
  () => import("./chunk422.js").then((e) => ({
    default: e.ReactQueryDevtools
  }))
), D = ({ showDevtools: e = !1 }) => e && /* @__PURE__ */ r(c, { children: /* @__PURE__ */ r(h, {}) }), Q = p(), v = y(), x = ({ children: e }) => {
  const [s, i] = u(!1);
  return a(() => {
    window.__TOGGLE_DEV_TOOLS__ = () => i((t) => !t);
  }, []), /* @__PURE__ */ n(
    d,
    {
      client: Q,
      persistOptions: {
        persister: v,
        dehydrateOptions: {
          shouldDehydrateQuery: (t) => {
            var o;
            return m(t) && ((o = t.meta) == null ? void 0 : o.cache) !== !1;
          }
        },
        maxAge: 1e3 * 60 * 60 * 24
      },
      children: [
        e,
        /* @__PURE__ */ r(f, {}),
        /* @__PURE__ */ r(D, { showDevtools: s })
      ]
    }
  );
};
export {
  x as QueryClientProvider,
  v as idbPersister,
  Q as queryClient
};
